import {Component, ElementRef, Input, OnDestroy} from '@angular/core';
import {enterAnimation} from '@app/support/animations/fade.animation';

@Component({
	selector: 'smooth-height',
	animations: [enterAnimation],
	template: `
		<div *ngIf="animationsDisabled; then contentOutlet"></div>
		<div [@enterAnimation] *ngIf="!animationsDisabled; then contentOutlet"></div>
		<ng-template #contentOutlet>
			<ng-content></ng-content>
		</ng-template>
	`,
	host: {
		/*    '[style.display]': '"block"',
		 '[style.overflow]': '"hidden"' */
	},
})
export class SmoothHeightComponent implements OnDestroy {
	public observer: any;
	public node: any;
	@Input() public animationsDisabled: boolean = false;

	constructor(private element: ElementRef) {
		/*    this.node = this.element.nativeElement;
		 fromEvent(window, 'resize')
		 .pipe(
		 debounceTime(1000)
		 ).subscribe(() => {
		 this.setStartHeight();
		 });
		 setTimeout(() => {
		 this.setStartHeight();
		 }, 200);
		 this.observer = new MutationObserver(() => {
		 this.setStartHeight();
		 });
		 this.observer.observe(this.node, {
		 childList: true,
		 subtree: true,
		 characterData: true,
		 });*/
	}

	public setStartHeight(): void {
		/*    console.log('caling');
		 let prev = this.node.style.height;
		 this.node.style.height = 'auto';
		 let newH = this.node.scrollHeight;
		 this.node.style.height = prev;
		 setTimeout(() => {
		 this.node.style.height = newH + 'px';
		 }, 50);*/
	}

	public ngOnDestroy(): void {
		/*this.observer.disconnect();*/
	}
}
